<template>
  <naj-box :title="local.executionRequest.title">
    <v-row>
      <v-col>
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.executionRequest.identityType"
          :value.sync="formModel.executionIdentityType"
          :items="socialTypesWithCommercialReg"
          item-text="name"
          item-value="id"
          validates="required"
          @change="resetForm"
        ></naj-input>
      </v-col>
      <v-col>
        <naj-input
          :type-id="formFieldType.text"
          :label="local.executionRequest.identityId"
          :value.sync="formModel.executionIdentityId"
          :validates="isVerifiedValidatorCalculation"
          @input="resetExecutionRequests"
        ></naj-input>
      </v-col>
      <v-col class="text-left">
        <naj-button
          square
          :loading="isChecking"
          :disabled="checkButtonIsDisabled || formModel.isVerified"
          class="mt-5"
          @click="check"
        >
          {{ local.personInformation.check }}
        </naj-button>
      </v-col>
    </v-row>
    <v-row>
      <naj-data-table
        :title="local.executionRequest.requestCodes"
        :headers="gridHeaders"
        :loading="isChecking"
        :items="formModel.executionRequests"
        :pagination="false"
        :disable-items-per-page="true"
      >
      </naj-data-table>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { local } from '@/local';
const {
  mapState: mapLUTState,
  mapActions: mapLUTActions,
} = createNamespacedHelpers('LookupsModule');
const { mapActions: mapLawsuitActions } = createNamespacedHelpers('LawsuitModule');
export default {
  inject: ['$validator'],
  props: {
    formModel: {
      type: Object,
      required: true,
      isVerified: null,
    },
  },
  data() {
    return {
      isChecking: false,
      gridHeaders: [
        {
          value: 'code',
          text: this.local.executionRequest.code,
          sortable: false,
        },
        {
          value: 'documentTypeName',
          text: this.local.executionRequest.documentTypeName,
          sortable: false,
        },
        {
          value: 'submittedDate',
          text: this.local.executionRequest.submittedDate,
          sortable: false,
        },
        {
          value: 'courtName',
          text: this.local.executionRequest.courtName,
          sortable: false,
        },
        {
          value: 'requestStatusName',
          text: this.local.executionRequest.requestStatusName,
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapLUTState(['socialTypesWithCommercialReg']),
    checkButtonIsDisabled() {
      return (!this.formModel.executionIdentityType || !this.formModel.executionIdentityId);
    },
    isVerifiedValidatorCalculation() {
      return `required${this.formModel.isVerified === false ? '' : '|isVerified:' + this.formModel.isVerified}`;
    },
  },
  created() {
    this.getSocialTypesWithCommercialReg();
  },
  methods: {
    ...mapLUTActions(['getSocialTypesWithCommercialReg']),
    ...mapLawsuitActions(['getPartyExecutionRequests']),
    check() {
      this.isChecking = true;
      this.$set(this.formModel, 'executionRequests', null);
      this.getPartyExecutionRequests(this.formModel)
        .then((res) => {
          this.$set(this.formModel, 'executionRequests', res.data);
          this.$set(this.formModel, 'isVerified', true);
        })
        .catch(() => {
          this.toaster.error(local.common.verificationFailed);
          this.isChecking = false;
          this.$set(this.formModel, 'isVerified', false);
        })
        .finally(() => { this.isChecking = false; });
    },
    resetForm() {
      this.$set(this.formModel, 'executionIdentityId', null);
      this.$set(this.formModel, 'executionRequests', null);
      this.$set(this.formModel, 'isVerified', null);
    },
    resetExecutionRequests() {
      this.$set(this.formModel, 'executionRequests', null);
      this.$set(this.formModel, 'isVerified', null);
    },
  },

};
</script>
